export default function SVG_Circle() {
  return (
    <div>
      <h1>SVG_Circle Component</h1>
    </div>
  );
}
